export { default } from "./HeroBlock";
